import React, { Component } from 'react';
import { bool, func, node, oneOfType, string } from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { SimpleText } from 'util/IntlMessages';

import { Button } from '../../Button';

import styles from './styles.module.scss';

class DestructiveConfirmationDialog extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.open !== nextProps.open;
  }

  render() {
    const { open, header, text, onCancel, buttonNo, onConfirm, buttonYes } = this.props;

    return (
      open && (
        <Dialog className="modal-box" open onClose={onCancel}>
          {header && <DialogTitle className="modal-text-header">{header}</DialogTitle>}
          <DialogContent>
            <DialogContentText className="modal-text-content">{text}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button size="large" variant="text" onClick={onCancel}>
              {buttonNo}
            </Button>
            <Button size="large" variant="contained" color="error" onClick={onConfirm}>
              {buttonYes}
            </Button>
          </DialogActions>
        </Dialog>
      )
    );
  }
}

DestructiveConfirmationDialog.propTypes = {
  buttonNo: oneOfType([node, string]),
  buttonYes: oneOfType([node, string]),
  header: oneOfType([node, string]),
  onCancel: func,
  onConfirm: func,
  open: bool,
  text: oneOfType([node, string]),
};

DestructiveConfirmationDialog.defaultProps = {
  buttonNo: <SimpleText id="modal.confirm.default.no" />,
  buttonYes: <SimpleText id="modal.confirm.default.yes" />,
  header: '',
  onCancel: () => {},
  onConfirm: () => {},
  open: false,
  text: <SimpleText id="modal.confirm.default.text" />,
};

export default DestructiveConfirmationDialog;
